import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {  map } from 'rxjs/operators';

import { objectToFormData } from '@teem/helpers/functions';
import { Serializer} from '@teem/core/generic/serializer';
import { Resource } from '@teem/core/generic/resource';


export class ResourceService<T extends Resource> {

	constructor(
		protected httpClient: HttpClient, 
    protected endpoint: string,
    protected serializer: Serializer) { }

  // Http Headers
  protected httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  }

  public create(item: any, options?:any ): Observable<T> {
    if(item.hasOwnProperty('id'))
      delete item.id;

    if(item.hasOwnProperty('uuid'))
      delete item.uuid;

    let fd = null;

    if(options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data' ) {
      fd = objectToFormData(item);
    } else {
      fd = item;
    }

    return this.httpClient
      .post<T>(`${this.endpoint}`, fd) //this.serializer.toJson(item))
      // .pipe(retry(1), catchError(this.errorHandler))
      .pipe(map(data => this.serializer.fromJson(data) as T));
  }

  public update(item: any, options?:any): Observable<T> {

    if(options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data' ) {
      let fd = objectToFormData(item);

      fd.append('_method', 'put');

      return this.httpClient
              .post<T>(`${this.endpoint}/${item.uuid}`, fd)
              .pipe(map(data => this.serializer.fromJson(data) as T));
    }

    return this.httpClient
      .put<T>(`${this.endpoint}/${item.uuid}`, item)
      .pipe(map(data => this.serializer.fromJson(data) as T));
  }

  public get(id: string, queryOptions?: any): Observable<T> {
    return this.httpClient
      .get(`${this.endpoint}/${id}${queryOptions ? ('?'+ this.toQueryString(queryOptions)) : ""}`)
      .pipe(map((data: any) => this.serializer.fromJson(data) as T));
  }

  public all(queryOptions?: any): Observable<T[]> {
    return this.httpClient
      .get(`${this.endpoint}${queryOptions ? ('?'+ this.toQueryString(queryOptions)) : ""}`)
      .pipe(map((r: any) => this.convertData(r.data)));
  }

  public delete(id: string) {
    return this.httpClient
      .delete(`${this.endpoint}/${id}`);
  }

  protected convertData(data: any): T[] {
    return data.map(item => this.serializer.fromJson(item));
  }

  protected toQueryString(paramsObject:any):string {
	 return Object
	 .keys(paramsObject)
	 .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
	 .join('&');
 	}

  // Error handling
  errorHandler(error) {
     let errorMessage = '';
     if(error.error instanceof ErrorEvent) {
       // Get client-side error
       errorMessage = error.error.message;
     } else {
       // Get server-side error
       errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
     }
     return throwError(errorMessage);
  }
}
